module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bootstrap/fonts/glyphicons-halflings-regular.eot
// module id = 257
// module chunks = 8